module.exports = __webpack_public_path__ + "img/Bodice-Back-Ka-Lb.5b14a042.png";